// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InsightPowerArrows_wrapper__e9J_l","wrapperReversed":"InsightPowerArrows_wrapperReversed__g9dDc","mediumArror":"InsightPowerArrows_mediumArror__xfIA6"};